var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: {
        close: _vm.closeModal,
        printButton: "",
        downloadButton: "",
        title: _vm.title,
        printStyle: _vm.printStyle,
      },
    },
    [
      _c("h3", { attrs: { slot: "modalHeader" }, slot: "modalHeader" }, [
        _c("i", { staticClass: "uk-icon-clock-o" }),
        _vm._v(" Записи в " + _vm._s(_vm.organ)),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "htmlContent",
          staticClass: "records-content",
          attrs: { slot: "modalBody" },
          slot: "modalBody",
        },
        [
          [
            _c("h4", { staticClass: "title" }, [
              _vm._v("Регистрационные действия " + _vm._s(_vm.companyName)),
            ]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "records-list" },
              _vm._l(_vm.records, function (r, i) {
                return _c("item", { key: i, attrs: { record: r } })
              }),
              1
            ),
          ],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }